// Registers the shell's own `shell` i18n namespace (tour popover chrome and the
// mock UIs of the tour demo animations) on the host's i18next instance.
//
// Same contract as a feature package's host (`host.i18n.addResourceBundle`):
// the shell never imports i18next to add bundles, the host passes its
// initialised instance in at bootstrap (src/app/register-shell.ts).
import vi from './vi.json'
import en from './en.json'

export interface ShellI18n {
    addResourceBundle: (lng: string, ns: string, resources: object) => unknown
}

export function registerShellLocales(i18n: ShellI18n): void {
    i18n.addResourceBundle('vi', 'shell', vi)
    i18n.addResourceBundle('en', 'shell', en)
}
